namespace pixi_ui.component {
    import TextStyleOptions = PIXI.TextStyleOptions;

    const defaultTextStyleOptions: TextStyleOptions = {
        fontSize: 22,
        fontFamily: 'arial',
        fill: 0x000000,
    };

    export class Text implements IComponent {
        public textStyleOptions: TextStyleOptions;
        public PIXIText: PIXI.Text;
        private _text: string;

        public get text(): string {
            return this._text;
        }

        public set text(text: string) {
            this._text = text;
            this.PIXIText.text = text;
        }

        constructor(text: string, textStyleOptions?: TextStyleOptions) {
            let options: any = {
                ...defaultTextStyleOptions,
                ...textStyleOptions,
            };
            this.PIXIText = new PIXI.Text(text, options);
            this._text = text;
        }

        public attach(element: Element): void {
            element.desiredWidth = this.PIXIText.width;
            element.desiredHeight = this.PIXIText.height;
            element.addChild(this.PIXIText);
        }

        public detach(element: Element): void {
            element.removeChild(this.PIXIText);
        }

        public resize(element: Element): void {
            element.desiredWidth = this.PIXIText.width;
            element.desiredHeight = this.PIXIText.height;
        }
    }
}
